<template>
    <div class="ppv2-h-full ppv2-min-h-full">
        <!-- v-if="!method.name.includes('Abonnement') && !method.name.includes('Cure') && !method.name.includes('cadeau')" -->
        <div class="form-check form-block ppv2-h-full ppv2-min-h-full">
            <slot name="checkbox"></slot>
            <label class="form-check-label card-design" :for="'checkbox_' + method.name">
                <div class="d-flex flex-column w-100 ppv2-gap-1">
                    <div class="w-100">
                        <p
                            class="poppinsSemiBold mb-0 ppv2-text-sm line-height-[1.4]"
                            style="color: inherit"
                            :title="method.display_name || method.name"
                        >
                            <span v-if="method.name.toLowerCase() == 'stripe'" class="ppv2-inline-block">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    width="50px"
                                    height="35px"
                                    viewBox="0 -149 512 512"
                                    version="1.1"
                                    preserveAspectRatio="xMidYMid"
                                >
                                    <g>
                                        <path
                                            d="M35.9822222,83.4844444 C35.9822222,77.9377778 40.5333333,75.8044444 48.0711111,75.8044444 C58.88,75.8044444 72.5333333,79.0755556 83.3422222,84.9066667 L83.3422222,51.4844444 C71.5377778,46.7911111 59.8755556,44.9422222 48.0711111,44.9422222 C19.2,44.9422222 0,60.0177778 0,85.1911111 C0,124.444444 54.0444444,118.186667 54.0444444,135.111111 C54.0444444,141.653333 48.3555556,143.786667 40.3911111,143.786667 C28.5866667,143.786667 13.5111111,138.951111 1.56444444,132.408889 L1.56444444,166.257778 C14.7911111,171.946667 28.16,174.364444 40.3911111,174.364444 C69.9733333,174.364444 90.3111111,159.715556 90.3111111,134.257778 C90.1688889,91.8755556 35.9822222,99.4133333 35.9822222,83.4844444 Z M132.124444,16.4977778 L97.4222222,23.8933333 L97.28,137.813333 C97.28,158.862222 113.066667,174.364444 134.115556,174.364444 C145.777778,174.364444 154.311111,172.231111 159.004444,169.671111 L159.004444,140.8 C154.453333,142.648889 131.982222,149.191111 131.982222,128.142222 L131.982222,77.6533333 L159.004444,77.6533333 L159.004444,47.36 L131.982222,47.36 L132.124444,16.4977778 Z M203.235556,57.8844444 L200.96,47.36 L170.24,47.36 L170.24,171.804444 L205.795556,171.804444 L205.795556,87.4666667 C214.186667,76.5155556 228.408889,78.5066667 232.817778,80.0711111 L232.817778,47.36 C228.266667,45.6533333 211.626667,42.5244444 203.235556,57.8844444 Z M241.493333,47.36 L277.191111,47.36 L277.191111,171.804444 L241.493333,171.804444 L241.493333,47.36 Z M241.493333,36.5511111 L277.191111,28.8711111 L277.191111,0 L241.493333,7.53777778 L241.493333,36.5511111 Z M351.431111,44.9422222 C337.493333,43.9422222 328.533333,51.4844444 323.555556,56.0355556 L321.706667,47.2177778 L290.417778,47.2177778 L290.417778,213.048889 L325.973333,205.511111 L326.115556,165.262222 C331.235556,168.96 338.773333,174.222222 351.288889,174.222222 C376.746667,174.222222 399.928889,153.742222 399.928889,108.657778 C399.786667,67.4133333 376.32,44.9422222 351.431111,44.9422222 Z M342.897778,142.933333 C334.506667,142.933333 329.528889,139.946667 326.115556,136.248889 L325.973333,83.4844444 C329.671111,79.36 334.791111,76.5155556 342.897778,76.5155556 C355.84,76.5155556 364.8,91.0222222 364.8,109.653333 C364.8,128.711111 355.982222,142.933333 342.897778,142.933333 Z M512,110.08 C512,73.6711111 494.364444,44.9422222 460.657778,44.9422222 C426.808889,44.9422222 406.328889,73.6711111 406.328889,109.795556 C406.328889,152.604444 430.506667,174.222222 465.208889,174.222222 C482.133333,174.222222 494.933333,170.382222 504.604444,164.977778 L504.604444,136.533333 C494.933333,141.368889 483.84,144.355556 469.76,144.355556 C455.964444,144.355556 443.733333,139.52 442.168889,122.737778 L511.715556,122.737778 C511.715556,120.888889 512,113.493333 512,110.08 Z M441.742222,96.5688889 C441.742222,80.4977778 451.555556,73.8133333 460.515556,73.8133333 C469.191111,73.8133333 478.435556,80.4977778 478.435556,96.5688889 L441.742222,96.5688889 L441.742222,96.5688889 Z"
                                            fill="#6772E5"
                                        ></path>
                                    </g>
                                </svg>
                            </span>
                            <span v-else-if="method.name.toLowerCase() == 'klarna'" class="ppv2-inline-block">
                                <svg width="40" height="45" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M35.3046 12.375H4.69536C2.10218 12.375 0 14.4772 0 17.0704V23.8594C0 26.4526 2.10218 28.5548 4.69536 28.5548H35.3046C37.8978 28.5548 40 26.4526 40 23.8594V17.0704C40 14.4772 37.8978 12.375 35.3046 12.375Z"
                                        fill="#FFB3C7"
                                    />
                                    <path
                                        d="M32.0309 19.4643C31.6586 19.2106 31.2241 19.0632 30.7742 19.0381C30.3244 19.0129 29.8761 19.1109 29.4778 19.3214C29.0795 19.532 28.7461 19.8473 28.5136 20.2332C28.2811 20.6192 28.1582 21.0612 28.1582 21.5118C28.1582 21.9624 28.2811 22.4044 28.5136 22.7903C28.7461 23.1763 29.0795 23.4915 29.4778 23.7021C29.8761 23.9127 30.3244 24.0107 30.7742 23.9855C31.2241 23.9603 31.6586 23.813 32.0309 23.5592V23.8592H33.4367V19.164H32.0309V19.4643ZM30.7524 22.7198C30.5162 22.7073 30.2889 22.6258 30.0985 22.4854C29.9082 22.3449 29.7632 22.1518 29.6814 21.9299C29.5997 21.7079 29.5848 21.4669 29.6386 21.2366C29.6925 21.0062 29.8126 20.7967 29.9842 20.634C30.1559 20.4713 30.3715 20.3624 30.6043 20.3209C30.8372 20.2794 31.0771 20.307 31.2944 20.4004C31.5117 20.4939 31.6968 20.6489 31.8269 20.8464C31.957 21.044 32.0263 21.2753 32.0263 21.5118C32.0173 21.8409 31.8781 22.1529 31.6393 22.3794C31.4004 22.6059 31.0814 22.7283 30.7524 22.7198Z"
                                        fill="black"
                                    />
                                    <path d="M12.7524 17.0715H11.2812V23.8593H12.7524V17.0715Z" fill="black" />
                                    <path
                                        d="M25.6616 19.0376C25.3852 19.0213 25.109 19.0724 24.8567 19.1866C24.6045 19.3007 24.3838 19.4745 24.2136 19.693V19.1642H22.8136V23.8593H24.2304V21.3918C24.2196 21.2501 24.2393 21.1077 24.2884 20.9743C24.3375 20.8408 24.4147 20.7195 24.5148 20.6186C24.6149 20.5177 24.7356 20.4395 24.8686 20.3894C25.0017 20.3393 25.1439 20.3184 25.2858 20.3282C25.9036 20.3282 26.2588 20.6973 26.2588 21.3821V23.8593H27.663V20.8734C27.663 19.7807 26.7942 19.0376 25.6616 19.0376Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M17.2001 19.4643C16.8278 19.2106 16.3933 19.0632 15.9434 19.0381C15.4935 19.0129 15.0453 19.1109 14.647 19.3214C14.2487 19.532 13.9153 19.8473 13.6828 20.2332C13.4503 20.6192 13.3274 21.0612 13.3274 21.5118C13.3274 21.9624 13.4503 22.4044 13.6828 22.7903C13.9153 23.1763 14.2487 23.4915 14.647 23.7021C15.0453 23.9127 15.4935 24.0107 15.9434 23.9855C16.3933 23.9603 16.8278 23.813 17.2001 23.5592V23.8592H18.6059V19.164H17.2001V19.4643ZM15.9215 22.7198C15.6853 22.7073 15.458 22.6258 15.2676 22.4854C15.0773 22.345 14.9322 22.1519 14.8505 21.93C14.7687 21.708 14.7538 21.467 14.8076 21.2366C14.8614 21.0063 14.9816 20.7968 15.1532 20.634C15.3248 20.4713 15.5404 20.3624 15.7732 20.3209C16.0061 20.2794 16.246 20.307 16.4633 20.4004C16.6806 20.4938 16.8658 20.6489 16.9959 20.8464C17.126 21.044 17.1953 21.2753 17.1953 21.5118C17.1863 21.8409 17.0472 22.1529 16.8083 22.3794C16.5695 22.6059 16.2505 22.7283 15.9215 22.7198H15.9215Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M20.7804 19.7757V19.1642H19.3411V23.8595H20.7835V21.6675C20.7835 20.9278 21.5851 20.5303 22.1414 20.5303C22.147 20.5303 22.1525 20.5309 22.1581 20.5309V19.1644C21.8975 19.1575 21.6385 19.2087 21.4002 19.3144C21.1618 19.4202 20.9501 19.5778 20.7804 19.7757Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M34.9292 22.1941C34.7547 22.1941 34.5841 22.2459 34.439 22.3428C34.2939 22.4398 34.1808 22.5776 34.114 22.7388C34.0473 22.9 34.0298 23.0775 34.0638 23.2486C34.0979 23.4198 34.1819 23.577 34.3053 23.7004C34.4287 23.8238 34.5859 23.9078 34.7571 23.9419C34.9283 23.9759 35.1057 23.9584 35.2669 23.8916C35.4281 23.8249 35.5659 23.7118 35.6629 23.5667C35.7598 23.4216 35.8116 23.251 35.8116 23.0765C35.8116 22.9606 35.7888 22.8458 35.7444 22.7388C35.7001 22.6317 35.6351 22.5344 35.5532 22.4525C35.4712 22.3706 35.3739 22.3056 35.2669 22.2612C35.1598 22.2169 35.0451 22.1941 34.9292 22.1941Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M10.2669 17.0703H8.74225C8.74461 17.6818 8.60315 18.2852 8.3293 18.8319C8.05545 19.3786 7.65688 19.8532 7.16577 20.2174L6.56177 20.6698L8.90229 23.8615H10.8265L8.67305 20.9247C9.18092 20.4199 9.58337 19.8192 9.857 19.1575C10.1306 18.4958 10.27 17.7864 10.2669 17.0703Z"
                                        fill="black"
                                    />
                                    <path d="M6.37542 17.0703H4.84802V23.8612H6.37542V17.0703Z" fill="black" />
                                </svg>
                            </span>
                            <span class="text-methode poppinsSemiBold" v-else>
                                {{ method.display_name || method.name }}
                            </span>
                        </p>
                    </div>
                    <div class="moyen-paiement w-100 ppv2-flex ppv2-justify-center ppv2-text-black">
                        <slot name="input"></slot>
                    </div>
                </div>
            </label>
        </div>
        <!-- <div v-else>
            <input type="hidden" :name="'payments[' + method.name + ']'" v-model="method.value" />
        </div> -->
    </div>
</template>

<style scoped>
.moyen-paiement .form-control {
    text-align: center;
    background-color: transparent;
    border: 1px solid #e2e8f0;
    height: 30px !important;
    min-width: 50px !important;
    border-radius: 8px;
    padding: 0 8px !important;
    font-size: clamp(12px, 0.729545vw, 16px) !important;
    font-weight: 600;
    line-height: normal !important;
    transition: all 0.2s ease;
}

.moyen-paiement .form-control:focus {
    background-color: #fff;
    border-color: #7d2dbd;
    box-shadow: 0 0 0 2px rgba(125, 45, 189, 0.1);
    outline: none;
}

.card-design {
    border: 1.5px solid #e2e8f0 !important;
    border-radius: 12px !important;
    min-height: 70px !important;
    /*height: auto !important;*/
    padding: 8px 0 !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
}

.card-design:hover {
    border-color: #cbd5e1 !important;
    background: #f8fafc;
    transform: translateY(-1px);
}

.form-block .form-check-label {
    padding: 8px 12px !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
}

.form-block .form-check-input:checked ~ .form-check-label {
    background: #f5f3ff;
    border-color: #7d2dbd !important;
    color: #7d2dbd;
}

.form-block .form-check-input:checked ~ .form-check-label .moyen-paiement .form-control {
    background: #fff;
    border-color: #7d2dbd;
    color: #7d2dbd;
}

.form-block .form-check-input:checked ~ .form-check-label .text-methode {
    color: #7d2dbd;
    font-weight: 600;
}

span.text-methode {
    color: #475569;
}
</style>

<script>
import normalizeSize from '../../../utils/normalizeSize'

export default {
    props: ['method', 'remainPrice'],
    methods: {
        normalizeSize,
    },
}
</script>
